// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import SurveyCompletions from "../../../components/SurveyCompletions.js";

const Completions = () => {
  return (
    <>
      <Header
        title="Survey Completions"
        description="Survey Completion Description"
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <SurveyCompletions />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Completions;
